export const tableCustomStyles = {
  headRow: {
    style: {
      minHeight: '3rem',
    },
  },
  headCells: {
    style: {
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '13px',
      lineHeight: '100%',
      letterSpacing: '0%',
      color: '#838486',
    },
  },
  rows: {
    style: {
      padding: '1rem',
    },
  },
  cells: {
    style: {
      fontSize: '13px',
    },
  },
};
